import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MasterUserOfCustomer } from '@dto/masterUserOfCustomer';
import { TransactionDeliveryNoteDto } from '@dto/transactionDeliveryNoteDto';
import { DeliveryNoteTemplateType } from '@enums/deliveryNoteTemplateType.enum';
import { DeliveryNote } from '@models/deliveryNote';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FilesService } from '@services/files/files.service';
import { UsersService } from '@services/entity/users.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { CustomersService } from '../../../services/entity/customers.service';
import { UserProfile } from '../../../dto/userProfile';
import { UserDto } from '../../../dto/userDto';
import { plainToClass } from 'class-transformer';

@Component({
  selector: 'app-delivery-note-template',
  templateUrl: './delivery-note-template.component.html',
  styleUrls: ['./delivery-note-template.component.scss']
})
export class DeliveryNoteTemplateComponent implements OnInit {

  public type: number;
  public deliveryNote: DeliveryNote;
  public deliveryUser: UserDto;
  public transactions: TransactionDeliveryNoteDto[];
  public currentPage = 1;
  public transactionsOfPage: Map<number, TransactionDeliveryNoteDto[]>;
  public pdfPageImages: Map<number, string>;

  public masterUserOfCustomer: UserProfile;
  public loading: boolean = true;

  private TRANSACTIONS_PER_PAGE = 14;
  public pageCount: number;

  private canvasHeight: number;
  private canvasWidth: number;

  public kwhAmount;
  public priceTag;
  public createdAt;
  public headerPicture;
  public footerPicture;
  public isCustomDelivery: boolean;
  public profile: UserProfile;

  @ViewChild('pdfTable') pdfTable: ElementRef;

  constructor(
    private cdref: ChangeDetectorRef,
    public activeModal: NgbActiveModal,
    private filesService: FilesService,
    private customersService: CustomersService,
    private usersService: UsersService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.getSettings();
    this.loadPictures();
    this.loading = true;
    this.calculateData();
  }

  getSettings() {
    this.usersService.getUserProfile().subscribe(result => {
      this.profile = result;
      this.isCustomDelivery = this.profile.settings?.customDeliveryNotes;
    }, error => {});

  }

  //ngAfterViewInit() {
  //  this.createCanvasData(this.currentPage);
  //}

  loadPictures() {
    this.filesService.getPicture("email/image/lieferschein_kopf.jpg", true).subscribe(result => {
      var unsafeImageUrl = URL.createObjectURL(result);
      this.headerPicture = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);

      if (this.headerPicture && this.footerPicture) {
        this.cdref.detectChanges();
        this.createCanvasData(this.currentPage);
      }
    }, error => {
      console.error(error);
      
    })

    this.filesService.getPicture("email/image/cubos_logo_schwarz.png", true).subscribe(result => {
      var unsafeImageUrl = URL.createObjectURL(result);
      this.footerPicture = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);

      if (this.headerPicture && this.footerPicture) {
        this.cdref.detectChanges();
        this.createCanvasData(this.currentPage);
      }
    }, error => {
      console.error(error);
    })
  }

  calculateData() {
    this.pageCount = Math.ceil(this.transactions.length / this.TRANSACTIONS_PER_PAGE);

    this.transactionsOfPage = new Map<number, TransactionDeliveryNoteDto[]>();
    this.pdfPageImages = new Map<number, string>();

    var page = 1;
    var counter = 0;
    var transactionsOfPage = [];
    var amount = 0;
    var price = 0;

    this.transactions.forEach(transaction => {
      amount += Number(transaction.meterAmount);
    });

    this.kwhAmount = amount;
    this.priceTag = `${(amount * price).toFixed(2).toLocaleString()} €`;
    this.createdAt = new Date();

    this.transactions.forEach(transaction => {
      transactionsOfPage.push(transaction);
      counter++;

      if (counter >= this.TRANSACTIONS_PER_PAGE) {
        this.transactionsOfPage.set(page, transactionsOfPage);
        page++;
        counter = 0;
        transactionsOfPage = [];
      }
    })

    this.transactionsOfPage.set(page, transactionsOfPage);
  }

  createPdf(canvasHeight: number, canvasWidth: number) {
    var pdf = new jsPDF('p', 'mm', 'a4',  true);

    var fileWidth = pdf.internal.pageSize.getWidth();
    var fileHeight = pdf.internal.pageSize.getHeight();
    var heightLeft = fileHeight;

    var position = 0;
    pdf.addImage(this.pdfPageImages.get(1), 'PNG', 0, position, fileWidth, fileHeight);

    if (this.pageCount > 1) {
      for (var i = 2; i <= this.pageCount; i++) {
        position += heightLeft - fileHeight;
        pdf.addPage();
        pdf.addImage(this.pdfPageImages.get(i), 'PNG', 0, position, fileWidth, fileHeight);
      }
    }

    this.loading = false;

    if (this.type == DeliveryNoteTemplateType.Download) {
      // pdf.save(this.deliveryNote.deliveryNoteNumber + '_' + this.profile.firstName + '_' + this.profile.lastName + '.pdf');
      pdf.save(this.deliveryNote.deliveryNoteNumber + '.pdf');
      this.activeModal.close();
    } else if (this.type == DeliveryNoteTemplateType.Email) {
      var blobPDF = new Blob([pdf.output('blob')], { type: 'application/pdf' });
      this.activeModal.close({ pdf: blobPDF });
    }
  }

  createCanvasData(page: number) {
    if (page > this.pageCount) {
      this.createPdf(this.canvasHeight, this.canvasWidth);
      return;
    }

    if (this.isCustomDelivery) {
      var data = document.getElementById('pdfTableCustom');
    } else {
      var data = document.getElementById('pdfTable');
    }

    html2canvas(data, { scale: 2 }).then(canvas => {
      this.canvasHeight = canvas.height;
      this.canvasWidth = canvas.width;

      this.pdfPageImages.set(page, canvas.toDataURL('image/png'));

      this.currentPage++;
      this.cdref.detectChanges();

      this.createCanvasData(this.currentPage);
    });
  }
}
